<template>
  <section>
    <v-server-table
      id="hearingLossRulesTable"
      ref="hearingLossRulesTable"
      :columns="columns"
      :options="tableOptions"
      @row-click="onRowClicked"
    >
      <span slot="questionnaire" slot-scope="props">
        {{ $t('hearinglossrules.labels.>=') }} {{props.row.min_quest_value}}
      </span>
      <span slot="hearing_test" slot-scope="props">
        {{ $t('hearinglossrules.labels.threshold_type.' + props.row.threshold_type) }} {{props.row.threshold}} dB HL
      </span>
      <span slot="diagnosed_hl" slot-scope="props">
        {{ $t('hearinglossrules.labels.' + props.row.diagnosed_hl) }}
      </span>
      <span slot="hearing_aid" slot-scope="props">
        {{ $t('hearinglossrules.labels.' + props.row.hearing_aid) }}
      </span>
      <span slot="h__questionnaire">{{ $t('hearinglossrules.labels.questionaire') }}</span>
      <span slot="h__hearing_test">{{ $t('hearinglossrules.labels.hearing_test') }}</span>
    </v-server-table>

    <ShowHearingLossRule
      v-if="selectedHearingLossRule !== null"
      :hearingLossRule="selectedHearingLossRule"
      :entity="entity"
      @rule-deleted="onRuleDeleted"
      @rule-updated="onRuleUpdated"
      @cancel="onCancelShowRule"
    />

  </section>
</template>

<script>
import TableQueryMixin from '@/mixins/TableQueryMixin'
import ShowHearingLossRule from '@/components/entities/hearinglossrules/ShowHearingLossRule'

export default {
  props: {
    entity: {
      type: Object,
      required: true
    },
    collapsed: {
      type: Boolean,
      required: false
    }
  },
  mixins: [
    TableQueryMixin
  ],
  components: {
    ShowHearingLossRule
  },
  data: function () {
    return {
      columns: ['hearing_test', 'questionnaire', 'diagnosed_hl', 'hearing_aid'],
      queryUrl: this.$store.state.evollead_server + '/entities/' + this.entity.id + '/hearinglossrules',
      tableOptions: {
        rowClassCallback: function (row) {
          if (row.selected) {
            return 'highlight'
          }
        },
        sortable: [],
        columnsDropdown: false,
        saveState: false,
        headings: {
          diagnosed_hl: this.$t('hearinglossrules.labels.diagnosed_hl'),
          hearing_aid: this.$t('hearinglossrules.labels.hearing_aid')
        }
      },
      selectedHearingLossRule: null
    }
  },
  methods: {
    refresh: function () {
      this.$refs.hearingLossRulesTable.refresh()
    },
    onRowClicked: function ({ row }) {
      this.selectedHearingLossRule = row
    },
    onRuleUpdated: function ({ hearingLossRule }) {
      this.refresh()
      console.log(hearingLossRule)
      this.selectedHearingLossRule = hearingLossRule
    },
    onRuleDeleted: function () {
      this.refresh()
    },
    onCancelShowRule: function () {
      this.selectedHearingLossRule = null
    }
  },
  watch: {
    entity: function (value) {
      this.refresh()
    }
  }
}
</script>

<style lang="scss">
  #hearingLossRulesTable {
    .VueTables__search {
      display: none;
    }
  }
</style>
